import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#0B2A4A',
          colorInfo: '#4DA3FF',
          colorWarning: '#D6A63A',
          borderRadius: 12,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "SF Pro Display", "PingFang SC", sans-serif',
        },
        components: {
          Layout: { siderBg: '#071D31', headerBg: 'rgba(255,255,255,.86)' },
          Card: { borderRadiusLG: 18 },
        },
      }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>,
);
